import answerAsExpected from 'core/controllerPlans/answerAsExpected'
import store from 'utils/store/withMiddleware'
import { getPivotBlueshiftParams } from 'core/services/email/blueshift/implementations/generic'
import storage from 'proxy-storage'
import { IS_AGENT, IS_ENROLL } from 'core/constants/environment'
import { STM_INELIGIBLE } from 'core/constants/eligibility'
import { ISC } from 'core/constants/channels'
import { sendBlueshiftEvent, BlueshiftEvent } from 'core/services/email/blueshift'

export function sendUserEligibilityEvent(): Promise<void> {
  const state = <Pivot.GenericKeyPair<any>>store.getState()
  const { questions, answersPivot } = state
  const hcStorage = storage.getItem('hc')

  let hasWrongAnswer = false
  if (!IS_ENROLL && !IS_AGENT) {
    for (const question of questions) {
      const answer = answersPivot[`q${question.id}`]
      const asExpected = answerAsExpected(answer, question.expected)

      if (!asExpected && answer) {
        hasWrongAnswer = true
        break
      }
    }
  } else {
    hasWrongAnswer = hcStorage.leadStatus == STM_INELIGIBLE
  }

  const dataPayload = {
    ...getPivotBlueshiftParams(),
    eligibility: !hasWrongAnswer
  }

  return sendBlueshiftEvent({
    dataPayload,
    eventName:
      dataPayload.sales_channel === ISC
        ? BlueshiftEvent.ISC_ELIGIBILITY_VIEW
        : BlueshiftEvent.ELIGIBILITY_VIEW,
    sanitize: true
  })
}
